export default { sha: 'd24601a28051fc7094e4f7670b1dc14ab04554fb', buildNumber: 'undefined' }
